import {HTMLAttributes} from 'react';
import {twMerge} from '../../../common/twMerge';

export function DialogList({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={twMerge(
        'px-28pxr pb-20pxr space-y-20pxr flex flex-col',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export const DialogListType = (<DialogList />).type;
